import React, { useState } from 'react'
import TotalUsers from './User/TotalUser'
import Subscribers from './Subscribers/Subscribers'
import PaymentDashboard from './paymentData'
import { Tabs, Tab } from 'react-bootstrap'

const DashbordPage = () => {

  const [loading, setLoading] = useState(false);
  const [activeTab, setActiveTab] = useState('users')


  return (
    <>
      <div className="custom_container px-0">
        {loading && <div className="page-loading">
          <img src="/images/loader.gif" alt="loader" />
        </div>}
        <Tabs
          activeKey={activeTab}
          onSelect={(k) => setActiveTab(k)}
          className="gap-3 summary-tab"
        >
          <Tab eventKey="users" title="Users">
            <TotalUsers />
          </Tab>
          <Tab eventKey="subscribers" title="Subscribers">
            <Subscribers />
          </Tab>
          {/* <Tab eventKey="payment" title="Revenue">
            <PaymentDashboard />
          </Tab> */}
        </Tabs>
      </div>
    </>
  )
}

export default DashbordPage